export const AUTOMATIC_META_PREFIX = "sb:auto:";

export const isAutomaticMetaKey = (key?: string | null): boolean =>
  (key ?? "").trim().toLowerCase().startsWith(AUTOMATIC_META_PREFIX);

export const automaticMetaNote = "Generated from the page content. A later content save replaces this value. Add a description entry to set the public description yourself.";
